module.exports = __webpack_public_path__ + "static/media/model-management-ic.9d8d72fe.svg";